/**
 * intc-shipping-bar.js
 *
 * Refreshes the #intc-shipping-bar snippet's text + fill width whenever the
 * cart changes, without a full page reload. Fetches /cart.js (Shopify's
 * standard cart JSON endpoint) and recomputes against the fixed, client
 * confirmed free-shipping threshold of $60.00 (6000 cents).
 *
 * Hooks into Dawn's existing global pub/sub system (assets/global.js /
 * assets/constants.js) via PUB_SUB_EVENTS.cartUpdate when available, and
 * also refreshes once on DOMContentLoaded.
 */
(function () {
  var INTC_THRESHOLD_CENTS = 6000;

  function intcFormatMoney(cents) {
    var amount = cents / 100;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      try {
        var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: window.Shopify.currency.active,
        });
        return formatter.format(amount);
      } catch (e) {
        // fall through to plain fallback below
      }
    }
    return '$' + amount.toFixed(2);
  }

  function intcUpdateShippingBar(totalPriceCents) {
    var wrapper = document.getElementById('intc-shipping-bar');
    if (!wrapper) return;

    var textEl = wrapper.querySelector('.intc-shipping-bar__text');
    var fillEl = wrapper.querySelector('.intc-shipping-bar__fill');
    if (!textEl || !fillEl) return;

    var percent = (totalPriceCents / INTC_THRESHOLD_CENTS) * 100;
    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;

    if (totalPriceCents >= INTC_THRESHOLD_CENTS) {
      textEl.textContent = "You’ve unlocked free shipping!";
    } else {
      var remainingCents = INTC_THRESHOLD_CENTS - totalPriceCents;
      textEl.textContent = "You’re " + intcFormatMoney(remainingCents) + ' away from free shipping';
    }

    fillEl.style.width = percent + '%';
  }

  function intcRefreshShippingBar() {
    var wrapper = document.getElementById('intc-shipping-bar');
    if (!wrapper) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        intcUpdateShippingBar(cart.total_price);
      })
      .catch(function () {
        // Network/parse error — leave server-rendered state as-is.
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    intcRefreshShippingBar();

    // Wiring the subscribe call here (instead of at top-level module scope)
    // guarantees global.js/constants.js have already executed and defined
    // `subscribe`/`PUB_SUB_EVENTS`, regardless of relative <script> order —
    // avoids a race where this check ran too early and silently skipped
    // live cart-update wiring, leaving the fill stuck at its initial width.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, intcRefreshShippingBar);
    }
  });
})();
